// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconFish = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M18 12a1 1 0 11-2 0 1 1 0 012 0" />,
    <path
      fillRule="evenodd"
      d="M12.853 5C17.416 5 21.33 8.093 23 12.5c-1.67 4.407-5.584 7.5-10.147 7.5-3.574 0-6.75-1.898-8.762-4.84L3 16.616l-1.8-.6V8.6L3 8l1.23 1.64C6.247 6.813 9.36 5 12.853 5m-.008 13c-3.366-.004-6.425-2.148-7.971-5.5 1.437-3.116 4.18-5.187 7.262-5.468A10.9 10.9 0 0011 11.91c0 2.267.681 4.372 1.845 6.09m2.265-.328c2.439-.72 4.53-2.587 5.723-5.172-1.312-2.845-3.713-4.82-6.467-5.354A8.86 8.86 0 0013 11.909c0 2.236.805 4.258 2.11 5.763"
    />
  );
export default SvgIconFish;
